import { simpleLookupConfig } from "../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "./../lookupManagement";

export const vsObjectName = "gamingContractFeeStructureType";

const url = "api/contract/gamingContract/feeStructureType";

export const FeeStructureTypeConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Fee Structure Type",
    url,
  }
);
